import { combineReducers } from "redux";

import { IStoreState } from "./initialStoreState";
import { messageReducer } from "./messages/messagesReducer";

import { commonReducer } from "./common/commonReducer";

import { UserProfileReducer } from "./UserProfileList/userProfileReducer";

import { activityReducer } from "./activity/activityReducer";
import { customizerReducer } from "./customizer/customizerReducer";
import { leadsReducer } from "./leads/leadsReducer";
import { opportunitesReducer } from "./opportunites/opportunitesReducer";
import { studentReducer } from "./student/studentReducer";
import { templateReducer } from "./templates/templateReducer";

import { securityReducer } from "./security/securityReducer";
import { userDocumentReducer } from "./userDocument/userDocumentReducer";
import { userBranchReducer } from "./userBranch/userBranchReducer";
import { envConfigReducer } from "./envConfig/envConfigReducer";
import { companyInformationReducer } from "./CompanyInformation/companyInformationReducer";
import { bookingReducer } from "./booking/bookingReducer";
import { categoryReducer } from "./category/categoryReducer";
import { categoryTypeReducer } from "./categoryType/categoryTypeReducer";

import { marketCampaignReducer } from "./marketCampaign/marketCampaignReducer";
import { googleReviewReducer } from "./Review/reviewReducer";
import { companyOutletReducer } from "./companyOutlet/companyOutletReducer";
import { paymentDetailsReducer } from "./paymentDetails/paymentDetailsReducer";
import { metaDataReducer } from "./metaData/metaDataReducer";
import { contactsReducer } from "./contacts/contactsReducer";
import { bankDetailsReducer } from "./bankDetails/bankDetailsReducer";

import { companyOutletAddressReducer } from "./customerDeliveryAddress/companyOutletAddressReducer";
import { companyOutletAttachmentReducer } from "./customerVendorAttachment/companyOutletAttachmentReducer";
import { subscriptionPlanReducer } from "./subscription/subscriptionReducer";

import { orgEnvConfigReducer } from "./orgEnvConfig/orgEnvConfigReducer";
import { automationReducer } from "./automation/automationReducer";
import { statusReducer } from "./status/statusReducer";
// import { metaTemplateReducer } from "./metaTemplate/metaTemplateReducer";
import { foodReducer } from "./food/foodReducer";
import chatbotReducer from "./chatbot/chatbotReducer";
import { supportReducer } from "./support/supportReducer";
import { masterFormsReducer } from "./masterForm/masterFormsReducer";
import { serviceReducer } from "./service/serviceReducer";
import { eventReducer } from "./event/eventReducer";
import { formsReducer } from "./dynamicFormsV2/formsReducer";
import { genAiReducer } from "./genAi/genAiReducer";
import { whatsappTemplateReducer } from "./whatsappTemplate/whatsappTemplateReducer";
import { actionItemReducer } from "./actionItems";
import { quickReplyTemplateReducer } from "./quickReplyTemplates/quickReplyTemplateReducer";
import { restrictedWordsReducer } from "./restrictedWords/restrictedWordsReducer";
import { variantsReducer } from "./variants/variantsReducer";
import { upsellLeadsReducer } from "./upsellLead/upsellLeadsReducer";
const appReducer = combineReducers({
  customizerReducer: customizerReducer,
  student: studentReducer,
  message: messageReducer,
  acitivty: activityReducer,
  security: securityReducer,

  templates: templateReducer,

  userprofile: UserProfileReducer,
  common: commonReducer,
  companyInformation: companyInformationReducer,

  opportunites: opportunitesReducer,
  leads: leadsReducer,

  userDocument: userDocumentReducer,
  userBranch: userBranchReducer,
  envConfig: envConfigReducer,
  booking: bookingReducer,
  category: categoryReducer,
  categoryType: categoryTypeReducer,
  food: foodReducer,
  marketCampaign: marketCampaignReducer,
  review: googleReviewReducer,
  companyOutlet: companyOutletReducer,
  bankDetails: bankDetailsReducer,
  contacts: contactsReducer,
  companyOutletAddress: companyOutletAddressReducer,
  companyOutletAttachment: companyOutletAttachmentReducer,

  payment_details: paymentDetailsReducer,
  metaData: metaDataReducer,
  subscriptionPlan: subscriptionPlanReducer,
  orgEnvConfig: orgEnvConfigReducer,
  automation: automationReducer,
  status: statusReducer,
  // metaTemplate: metaTemplateReducer,
  whatsappTemplate: whatsappTemplateReducer,
  quickReplyTemplate: quickReplyTemplateReducer,
  chatbot: chatbotReducer,
  support: supportReducer,
  forms: formsReducer,
  masterForms: masterFormsReducer,
  service: serviceReducer,
  event: eventReducer,
  genAi: genAiReducer,
  actionItems: actionItemReducer,
  restrictedWords: restrictedWordsReducer,
  variants: variantsReducer,
  upsellLeads: upsellLeadsReducer,
});

export const rootReducer = (state: IStoreState | undefined, action: any) => {
  if (action.type === "USER_LOGOUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};
